angular.module('virtoCommerce.marketplaceModule')
    .factory('virtoCommerce.marketplaceModule.approvalPolicyTranslationService', ['$translate', function ($translate) {
        return {
            translateApprovalPolicies: function (rawStatuses) {
                return _.map(rawStatuses, function (x) {
                    return {
                        key: x,
                        value: translateApprovalPolicy(x, $translate)
                    };
                });
            }
        };
    }])
    // operation statuses localization filter
    //.filter('statusTranslate', ['$translate', function ($translate) {
    //    return function (statusOrOperation, operation) {
    //        operation = operation || statusOrOperation;
    //        return operation.status ? translateOrderStatus(operation.status, $translate) : '';
    //    };
    //}])
    ;

function translateApprovalPolicy(rawPolicy, $translate) {
    var translateKey = 'marketplace.settings.approval-policy.' + rawPolicy.toLowerCase();
    var result = $translate.instant(translateKey);
    return result === translateKey ? rawPolicy : result;
}
